var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { XFormInputContainer } from './XFormInputContainer';
export function XFormInputCurrency(input) {
    var value = input.value;
    var _a = useState((value || 0) / 100), tempValue = _a[0], setTempValue = _a[1];
    function handleChange(nextValue) {
        var _a;
        setTempValue(nextValue);
        if (nextValue || value) {
            (_a = input.onChange) === null || _a === void 0 ? void 0 : _a.call(input, Math.round(Number(nextValue) * 100));
        }
    }
    return (React.createElement(XFormInputContainer, __assign({}, input),
        React.createElement("input", __assign({}, input, { type: 'number', value: tempValue !== null && tempValue !== void 0 ? tempValue : '', onChange: function (event) {
                handleChange(event.target.value);
            } }))));
    //const { value } = input;
    //
    //function handleChange(value) {
    //    input.onChange(value);
    //}
    //
    //return <XFormInputNumber type={'number'} value={value} onChange={handleChange} />;
}
